import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Icons } from 'sarsaparilla';
import { addChange, clearChange, getRef } from '../../actions/changes';
import { TextInput, TextBoxInput, SelectInput } from './ValidationWrapper';
import { LinkProps } from '../../props/link';

import pageStyles from './StewardAssetEditPage.scss';
import styles from './LinkEdit.scss';

const propTypes = {
  value: LinkProps,
  linkType: PropTypes.string,
  onRemove: PropTypes.func,
  getRef: PropTypes.func.isRequired,
  addChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired
};

const linkTypeOptions = [
  { label: 'Select Type', value: '' },
  { label: 'Concessionaires', value: 'Concessionaires' },
  { label: 'Equipment Rental', value: 'Equipment Rental' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Flickr', value: 'Flickr' },
  { label: 'Google+', value: 'Google+' },
  { label: 'Local Partnerships', value: 'Local Partnerships' },
  { label: 'Map', value: 'Map' },
  { label: 'Official Web Site', value: 'Official Web Site' },
  { label: 'Reservation', value: 'Reservation' },
  { label: 'Twitter', value: 'Twitter' },
  { label: 'Virtual Tours', value: 'Virtual Tours' },
  { label: 'YouTube Channel', value: 'YouTube Channel' },
  { label: 'Other', value: 'Other' }
];

export class LinkEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      record: this.props.value,
      ref: this.props.getRef(
        this.props.linkType,
        { id: this.props.value.id },
        0,
        ['url', 'title'].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
      )
    };

    this.handleChange = this.handleChange.bind(this);
    this.doRemove = this.doRemove.bind(this);
  }

  handleChange(event) {
    const { dataset: { field }, value } = event.target;

    const change = { [field]: value };

    this.setState((prevState) => ({
      ...prevState,
      record: { ...prevState.record, ...change }
    }), () => this.props.addChange(this.state.ref, change));
  }

  doRemove() {
    if (this.props.value.id) {
      this.props.addChange(this.state.ref, { _delete: true });
    }
    else {
      this.props.clearChange(this.state.ref);
    }
    this.props.onRemove(this.props.value._key);
  }

  render() {
    const { record, ref } = this.state;

    return (
      <div className={pageStyles['section-box']}>
        <Button
          appearance="subtle-danger"
          onClick={this.doRemove}
          className={pageStyles['delete-button']}
          iconBeforeElement={<Icons.IconClose />} />
        <div className={styles['link-edit-column']}>
          <SelectInput
            label="Link Type"
            field="type"
            changeRef={ref}
            options={linkTypeOptions}
            fullWidth
            value={get(record, 'type')}
            onChange={this.handleChange} />
          <TextInput
            label="Link URL"
            field="url"
            required
            changeRef={ref}
            fullWidth
            value={get(record, 'url')}
            onChange={this.handleChange} />
          <TextInput
            label="Link Text"
            field="title"
            required
            changeRef={ref}
            fullWidth
            value={get(record, 'title')}
            onChange={this.handleChange} />
        </div>
        <div className={styles['link-edit-column']}>
          <TextBoxInput
            label="Link Description"
            field="description"
            fullWidth
            changeRef={ref}
            value={get(record, 'description')}
            onChange={this.handleChange} />
        </div>
      </div>
    );
  }
}

LinkEdit.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getRef,
  addChange,
  clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LinkEdit);
